export default function trustpilotReviews (document, moduleHTML, appEventEmitter) {
  const readMoreButton = moduleHTML.querySelector('[data-js-trustpilot-review-read-more]')
  const reviewText = moduleHTML.querySelector('[data-js-trustpilot-review-text]')

  readMoreButton.addEventListener('click', (event) => {
    ['hidden', 'h-12', 'ellipsis'].forEach((cls) => reviewText.classList.toggle(cls))
    readMoreButton.classList.add('hidden')
  })
}
